var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header" }, [
        _vm.activeName === "picture"
          ? _c("div", { staticClass: "dialog-title" }, [
              _c(
                "span",
                {
                  staticClass: "title-one title",
                  class: { "my-gallery": _vm.galleryActive === "myGallery" },
                  on: {
                    click: function ($event) {
                      _vm.togglesGalleryTypes("myGallery")
                    },
                  },
                },
                [_vm._v("我的图库")]
              ),
              !_vm.hideCommonGallery
                ? _c(
                    "span",
                    {
                      staticClass: "title-two title",
                      class: {
                        "my-gallery": _vm.galleryActive === "commonGallery",
                      },
                      on: {
                        click: function ($event) {
                          _vm.togglesGalleryTypes("commonGallery")
                        },
                      },
                    },
                    [_vm._v("公共图库")]
                  )
                : _vm._e(),
            ])
          : _c("div", { staticClass: "dialog-title" }, [
              _c(
                "span",
                {
                  staticClass: "title my-gallery",
                  on: {
                    click: function ($event) {
                      _vm.togglesGalleryTypes("myGallery")
                    },
                  },
                },
                [_vm._v("我的音视频")]
              ),
            ]),
      ]),
      _vm.galleryActive === "myGallery" && _vm.activeName === "picture"
        ? _c("div", { staticClass: "gallery-wrapper" }, [
            _c("div", { staticClass: "gallery-category" }, [
              _c(
                "div",
                { staticClass: "category-tree category-tree-myGallery" },
                [
                  _c(
                    "el-scrollbar",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        wrapStyle:
                          "overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;",
                      },
                    },
                    [
                      _c("el-tree", {
                        key: "treePic",
                        ref: "treePic",
                        attrs: {
                          "empty-text": "",
                          data: _vm.pictureDirList,
                          props: { children: "_child", label: "name" },
                          "node-key": "id",
                          "default-expanded-keys": _vm.defaultExpandedkeys,
                          indent: 10,
                          "highlight-current": "",
                        },
                        on: { "node-click": _vm.clickPictureDir },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var node = ref.node
                              var data = ref.data
                              return _c(
                                "span",
                                { staticClass: "custom-tree-node" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "tree-item-node-name",
                                      class: {
                                        "tree-node-child": data.level > 0,
                                      },
                                      attrs: { title: data.name },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "tree-item-name" },
                                        [
                                          data.type === "group"
                                            ? _c("span", {
                                                staticClass:
                                                  "qm-icon qm-icon-group",
                                              })
                                            : data.type === "brand"
                                            ? _c("span", {
                                                staticClass:
                                                  "qm-icon qm-icon-brand",
                                              })
                                            : _c("span", {
                                                staticClass:
                                                  "qm-icon qm-icon-folder2",
                                              }),
                                          _c("span", [
                                            _vm._v(_vm._s(data.name)),
                                          ]),
                                        ]
                                      ),
                                      _c("span", { staticClass: "image-num" }, [
                                        _vm._v(_vm._s(data.count)),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "more-operations",
                                      class: {
                                        "is-show-add":
                                          data.type == "group" ||
                                          data.type == "brand",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        [
                                          data.type !== "group" &&
                                          data.type !== "brand"
                                            ? _c(
                                                "el-dropdown",
                                                {
                                                  attrs: { trigger: "hover" },
                                                  on: {
                                                    command: _vm.handleCommand,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-more delete-edit-operations",
                                                  }),
                                                  _c(
                                                    "el-dropdown-menu",
                                                    {
                                                      attrs: {
                                                        slot: "dropdown",
                                                      },
                                                      slot: "dropdown",
                                                    },
                                                    [
                                                      _c(
                                                        "el-dropdown-item",
                                                        {
                                                          attrs: {
                                                            command: {
                                                              type: "delete",
                                                              node: node,
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("删除")]
                                                      ),
                                                      _c(
                                                        "el-dropdown-item",
                                                        {
                                                          attrs: {
                                                            command: {
                                                              type: "rechristen",
                                                              node: node,
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("重命名")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "span",
                                        [
                                          data.level < 2
                                            ? _c(
                                                "el-dropdown",
                                                {
                                                  attrs: { trigger: "hover" },
                                                  on: {
                                                    command: _vm.handleCommand,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-plus add-operations",
                                                  }),
                                                  _c(
                                                    "el-dropdown-menu",
                                                    {
                                                      attrs: {
                                                        slot: "dropdown",
                                                      },
                                                      slot: "dropdown",
                                                    },
                                                    [
                                                      _c(
                                                        "el-dropdown-item",
                                                        {
                                                          attrs: {
                                                            command: {
                                                              type: "add",
                                                              node: node,
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("新建")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "gallery-main" }, [
              _c("div", { staticClass: "pictureNew-tit" }, [
                _c(
                  "div",
                  { staticClass: "searchImg" },
                  [
                    _c("el-input", {
                      staticClass: "search-img",
                      attrs: {
                        clearable: "",
                        placeholder: "请输入图片名称",
                        "prefix-icon": "el-icon-search",
                      },
                      on: {
                        input: function ($event) {
                          _vm.searchImagesResult(1)
                        },
                        clear: function ($event) {
                          _vm.emptySearchResults(1)
                        },
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          _vm.searchImages(1)
                        },
                      },
                      model: {
                        value: _vm.imageName,
                        callback: function ($$v) {
                          _vm.imageName = $$v
                        },
                        expression: "imageName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pictureNew-category-add" },
                  [
                    _c(
                      "el-upload",
                      {
                        ref: "uploadPicture",
                        staticClass: "upload-btn",
                        attrs: {
                          headers: _vm.uploadHeader,
                          action: _vm.uploadImgUrl,
                          data: _vm.uploadParam,
                          name: "upfile",
                          multiple: "",
                          "show-file-list": false,
                          "before-upload": _vm.beforeAvatarUpload,
                          "on-success": _vm.onSuccess,
                          "on-error": _vm.onError,
                          disabled: _vm.loadingUpload,
                          "with-credentials": "",
                          "http-request": _vm.uploadImage,
                        },
                      },
                      [
                        _c(
                          "el-button",
                          { staticClass: "qm-button" },
                          [
                            !_vm.loadingUpload
                              ? [
                                  _c("i", { staticClass: "qm-icon-upload" }),
                                  _vm._v("上传图片 "),
                                ]
                              : [
                                  _c("i", { staticClass: "qm-icon-upload" }),
                                  _vm._v("上传中... "),
                                ],
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-select",
                      {
                        staticClass: "batch-perationData",
                        attrs: { placeholder: "批量操作" },
                        model: {
                          value: _vm.batchPeration,
                          callback: function ($$v) {
                            _vm.batchPeration = $$v
                          },
                          expression: "batchPeration",
                        },
                      },
                      _vm._l(_vm.batchPerationData, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "image-wrapper" }, [
                _c("div", { staticClass: "image-list-main" }, [
                  _c(
                    "div",
                    { staticClass: "image-list-item" },
                    [
                      _c("div", { staticClass: "image-operation-panel" }, [
                        _vm.batchPeration
                          ? _c(
                              "div",
                              { staticClass: "select-images-num" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    staticClass: "checkAll",
                                    attrs: {
                                      size: "mini",
                                      indeterminate: _vm.isIndeterminate,
                                    },
                                    model: {
                                      value: _vm.checkAll,
                                      callback: function ($$v) {
                                        _vm.checkAll = $$v
                                      },
                                      expression: "checkAll",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  全选\n                  "
                                    ),
                                    _vm.selectImages.length > 0
                                      ? _c("span", [
                                          _vm._v(
                                            "已选中\n                    "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "image-operation-panel_num",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.selectImages.length)
                                              ),
                                            ]
                                          ),
                                          _vm._v("\n                    张"),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                                _vm.batchPeration == 1
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-picture",
                                        attrs: {
                                          type: "text",
                                          size: "mini",
                                          disabled: !_vm.selectImages.length,
                                        },
                                        on: { click: _vm.deleteSelectImages },
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "right",
                                      width: "300",
                                      trigger: "click",
                                    },
                                    model: {
                                      value: _vm.moveTreevisible,
                                      callback: function ($$v) {
                                        _vm.moveTreevisible = $$v
                                      },
                                      expression: "moveTreevisible",
                                    },
                                  },
                                  [
                                    _c("el-tree", {
                                      ref: "treeMovePic",
                                      attrs: {
                                        "empty-text": "",
                                        data: _vm.pictureDirList,
                                        props: {
                                          children: "_child",
                                          label: "name",
                                        },
                                        "node-key": "id",
                                        "default-expanded-keys": [0],
                                        "expand-on-click-node": false,
                                        indent: 10,
                                        "highlight-current": "",
                                      },
                                      on: {
                                        "node-click": _vm.moveImagesToTree,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var node = ref.node
                                            var data = ref.data
                                            return _c(
                                              "span",
                                              {
                                                staticClass: "custom-tree-node",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tree-item-node-name",
                                                    class: {
                                                      "tree-node-child":
                                                        data.id != 0,
                                                    },
                                                    attrs: { title: data.name },
                                                  },
                                                  [_vm._v(_vm._s(data.name))]
                                                ),
                                              ]
                                            )
                                          },
                                        },
                                      ]),
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.batchPeration == 2,
                                            expression: "batchPeration == 2",
                                          },
                                        ],
                                        staticClass: "delete-picture",
                                        attrs: {
                                          slot: "reference",
                                          disabled: !_vm.selectImages.length,
                                          type: "text",
                                          size: "mini",
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("移动\n                  ")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "cancel-delete-picture",
                                    attrs: { type: "text", size: "mini" },
                                    on: { click: _vm.cancelBatchOperations },
                                  },
                                  [_vm._v("取消")]
                                ),
                              ],
                              1
                            )
                          : _c("span", [
                              _vm._v("已选中"),
                              _c(
                                "span",
                                { staticClass: "image-operation-panel_num" },
                                [_vm._v(_vm._s(_vm.selectImages.length))]
                              ),
                              _vm._v("张"),
                            ]),
                      ]),
                      _c(
                        "el-scrollbar",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.imageListLoading,
                              expression: "imageListLoading",
                            },
                          ],
                          staticStyle: { height: "calc(100% - 36px)" },
                          attrs: {
                            wrapStyle:
                              "overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image-list" },
                            _vm._l(_vm.imagesList, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: "image+" + index,
                                  staticClass: "image-item",
                                  class: {
                                    active: _vm.checkboxStatus(item.id),
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.viewImageDetail(item)
                                    },
                                  },
                                },
                                [
                                  item.uploadState == "upload"
                                    ? _c(
                                        "div",
                                        { staticClass: "image-upload-loading" },
                                        [
                                          _c("div", { staticClass: "text" }, [
                                            _c("i", {
                                              staticClass: "el-icon-loading",
                                            }),
                                            _vm._v("上传中..."),
                                          ]),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small",
                                              },
                                              on: { click: _vm.abort },
                                            },
                                            [_vm._v("取消上传")]
                                          ),
                                        ],
                                        1
                                      )
                                    : item.uploadState == "success"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "image-item-main",
                                          class: {
                                            "batch-peration-show-btn":
                                              !_vm.batchPeration,
                                            "image-item-main-new":
                                              item.latestUpload,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.imageCheckboxChange(item)
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "image",
                                            attrs: {
                                              draggable: "false",
                                              src:
                                                item.domain + "/" + item.path,
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "image-title-bg image-title-show",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "image-name" },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item.name) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "image-title-bg image-download-magnify-delete",
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "qm-icon-enlarge",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    _vm.magnifyThePicture(item)
                                                  },
                                                },
                                              }),
                                              _c("span", [
                                                _vm.isShowClippingBtn(item.name)
                                                  ? _c("i", {
                                                      staticClass:
                                                        "qm-icon-crop",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          _vm.shearPictures(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _c("i", {
                                                  staticClass:
                                                    "qm-icon-download",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      _vm.downloadPic(item)
                                                    },
                                                  },
                                                }),
                                                _c("i", {
                                                  staticClass: "qm-icon-delete",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      _vm.deletePicture(item)
                                                    },
                                                  },
                                                }),
                                              ]),
                                            ]
                                          ),
                                          _vm.checkboxStatus(item.id)
                                            ? _c(
                                                "span",
                                                { staticClass: "state-check" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : item.uploadState == "error"
                                    ? _c(
                                        "div",
                                        { staticClass: "image-upload-loading" },
                                        [
                                          _c("div", { staticClass: "text" }, [
                                            _vm._v("上传失败"),
                                          ]),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.delUploadError(index)
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "image-operation-page" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.currentPage,
                          "page-sizes": _vm.customPageSizes,
                          "page-size": _vm.pageSize,
                          layout: "prev, pager, next,sizes",
                          total: _vm.total,
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.paginationChange,
                          "update:currentPage": function ($event) {
                            _vm.currentPage = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "image-detail-wrapper" },
                  [
                    _c("pictorial-information", {
                      attrs: {
                        imageInfo: _vm.imageInfo,
                        isShowMoreImage: _vm.isShowMoreImage,
                        selectImages: _vm.selectImages,
                        galleryType: 1,
                        galleryShowType: 1,
                      },
                      on: { saveImageInfo: _vm.saveImageInfo },
                    }),
                    _vm.showInsertBtn && !_vm.batchPeration
                      ? _c(
                          "div",
                          { staticClass: "gallery-control-wrapper" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: !_vm.selectImages.length,
                                },
                                on: { click: _vm.submitSelectImages },
                              },
                              [_vm._v("插入")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.galleryActive === "commonGallery" && _vm.activeName === "picture"
        ? _c("div", { staticClass: "gallery-wrapper" }, [
            _c("div", { staticClass: "gallery-category" }, [
              _c(
                "div",
                { staticClass: "category-tree" },
                [
                  _c(
                    "el-scrollbar",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        wrapStyle:
                          "overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;",
                      },
                    },
                    [
                      _c("el-tree", {
                        key: "treeCommonPic",
                        ref: "treeCommonPic",
                        attrs: {
                          "empty-text": "",
                          data: _vm.pictureCommonDirList,
                          props: { children: "_child", label: "name" },
                          "node-key": "id",
                          "default-expanded-keys": [0],
                          "expand-on-click-node": false,
                          indent: 10,
                          "highlight-current": "",
                        },
                        on: { "node-click": _vm.clickCommonPictureDir },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var node = ref.node
                              var data = ref.data
                              return _c(
                                "span",
                                { staticClass: "custom-tree-node" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "tree-item-node-name",
                                      class: {
                                        "tree-node-child": data.level > 0,
                                      },
                                      attrs: { title: data.name },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "tree-item-name" },
                                        [
                                          data.type === "group"
                                            ? _c("span", {
                                                staticClass:
                                                  "qm-icon qm-icon-group",
                                              })
                                            : data.type === "brand"
                                            ? _c("span", {
                                                staticClass:
                                                  "qm-icon qm-icon-brand",
                                              })
                                            : _c("span", {
                                                staticClass:
                                                  "qm-icon qm-icon-folder2",
                                              }),
                                          _c("span", [
                                            _vm._v(_vm._s(data.name)),
                                          ]),
                                        ]
                                      ),
                                      _c("span", { staticClass: "image-num" }, [
                                        _vm._v(_vm._s(data.count)),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "gallery-main" }, [
              _c("div", { staticClass: "pictureNew-tit" }, [
                _c(
                  "div",
                  { staticClass: "searchImg" },
                  [
                    _c("el-input", {
                      staticClass: "search-img",
                      attrs: {
                        clearable: "",
                        placeholder: "请输入图片名称",
                        "prefix-icon": "el-icon-search",
                      },
                      on: {
                        input: function ($event) {
                          _vm.searchImagesResult(2)
                        },
                        clear: function ($event) {
                          _vm.emptySearchResults(2)
                        },
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          _vm.searchImages(2)
                        },
                      },
                      model: {
                        value: _vm.imageName,
                        callback: function ($$v) {
                          _vm.imageName = $$v
                        },
                        expression: "imageName",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "image-wrapper" }, [
                _c("div", { staticClass: "image-list-main" }, [
                  _c(
                    "div",
                    { staticClass: "image-list-item" },
                    [
                      _c("div", { staticClass: "image-operation-panel" }, [
                        _c("span", [
                          _vm._v("已选中"),
                          _c(
                            "span",
                            { staticClass: "image-operation-panel_num" },
                            [_vm._v(_vm._s(_vm.selectImages.length))]
                          ),
                          _vm._v("张"),
                        ]),
                      ]),
                      _c(
                        "el-scrollbar",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.imageListLoading,
                              expression: "imageListLoading",
                            },
                          ],
                          staticStyle: { height: "calc(100% - 36px)" },
                          attrs: {
                            wrapStyle:
                              "overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image-list" },
                            _vm._l(
                              _vm.imagesCommonList,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: "image+" + index,
                                    staticClass: "image-item",
                                    class: {
                                      active: _vm.checkboxStatus(item.id),
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.viewImageDetail(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "image-item-main batch-peration-show-btn",
                                        on: {
                                          click: function ($event) {
                                            _vm.imageCheckboxChange(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "image",
                                          attrs: {
                                            draggable: "false",
                                            src: item.domain + "/" + item.path,
                                          },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "image-title-bg image-title-show",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "image-name" },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(item.name) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "image-title-bg image-download-magnify-delete magnify-common",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "qm-icon-enlarge",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  _vm.magnifyThePicture(item)
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm.checkboxStatus(item.id)
                                          ? _c(
                                              "span",
                                              { staticClass: "state-check" },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-check",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "image-operation-page" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.currentPage,
                          "page-sizes": _vm.customPageSizes,
                          "page-size": _vm.pageSize,
                          layout: "prev, pager, next,sizes",
                          total: _vm.total,
                        },
                        on: {
                          "size-change": _vm.handleCommonSizeChange,
                          "current-change": _vm.paginationCommonChange,
                          "update:currentPage": function ($event) {
                            _vm.currentPage = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "image-detail-wrapper" },
                  [
                    _c("pictorial-information", {
                      attrs: {
                        imageInfo: _vm.imageInfo,
                        isShowMoreImage: _vm.isShowMoreImage,
                        selectImages: _vm.selectImages,
                        galleryType: 0,
                        galleryShowType: 1,
                      },
                    }),
                    _vm.showInsertBtn && !_vm.batchPeration
                      ? _c(
                          "div",
                          { staticClass: "gallery-control-wrapper" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: !_vm.selectImages.length,
                                },
                                on: { click: _vm.submitSelectImages },
                              },
                              [_vm._v("插入")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.activeName === "video"
        ? _c(
            "div",
            [
              _c("VideoTutorials", {
                attrs: {
                  visible: _vm.visible,
                  multiple: _vm.multiple,
                  multipleLimit: _vm.multipleLimit,
                  sizeLimit: _vm.sizeLimit,
                  mediaTypes: _vm.mediaTypes,
                },
                on: { changeSelectVideo: _vm.changeSelectVideo },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: "",
            visible: _vm.dialogImgVisible,
            "custom-class": "qm-picture-library-enlarge-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogImgVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "pics" }, [
            _c("img", {
              attrs: { draggable: "false", src: _vm.dialogImg, alt: "" },
            }),
          ]),
        ]
      ),
      _c("deltree-pop", {
        ref: "deltreePop",
        attrs: { delType: 1 },
        on: { delTargetItem: _vm.delCategory },
      }),
      _c("image-clipping-popover", {
        attrs: {
          "image-clipping-visible": _vm.imageClippingVisible,
          "image-clipping-info": _vm.imageClippingInfo,
          "category-id": _vm.currentDir.category_id,
          "store-id": _vm.storeId,
        },
        on: {
          "update:imageClippingVisible": function ($event) {
            _vm.imageClippingVisible = $event
          },
          imageCroppingSuccess: _vm.imageCroppingSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }